const url = process.env.VUE_APP_API_URL;

export abstract class ApiUrl {
  public static readonly DISPOSER_INFO = `${url}/disposer-report`;
  public static readonly SUBMIT_QUOTE = `${url}/submit-recycling-quote`;
}
